import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import {
  ADMIN_PERMISSION_COLUMNS,
  ADMIN_PERMISSION_OBJECTS,
  AdminPermissionAction,
  AdminPermissionObject,
  AdminPermissionSelection,
} from "@/lib/admin-permissions"

type AdminPermissionMatrixProps = {
  value: AdminPermissionSelection
  onChange: (value: AdminPermissionSelection) => void
  idPrefix: string
  disabled?: boolean
}

export default function AdminPermissionMatrix({
  value,
  onChange,
  idPrefix,
  disabled = false,
}: AdminPermissionMatrixProps) {
  const setChecked = (
    object: AdminPermissionObject,
    action: AdminPermissionAction,
    checked: boolean,
  ) => {
    const current = value[object] ?? []
    onChange({
      ...value,
      [object]: checked
        ? [...new Set([...current, action])]
        : current.filter((item) => item !== action),
    })
  }

  return (
    <div className="overflow-x-auto rounded-md border">
      <table className="w-full min-w-[620px] text-sm">
        <thead className="bg-muted/50 text-left">
          <tr>
            <th className="px-3 py-2 font-medium">Permission</th>
            {ADMIN_PERMISSION_COLUMNS.map((column) => (
              <th key={column.action} className="px-3 py-2 text-center font-medium">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ADMIN_PERMISSION_OBJECTS.map((permission) => (
            <tr key={permission.object} className="border-t">
              <td className="px-3 py-3 font-medium">{permission.label}</td>
              {ADMIN_PERMISSION_COLUMNS.map((column) => {
                const id = `${idPrefix}-${permission.object}-${column.action}`
                return (
                  <td key={column.action} className="px-3 py-3 align-middle text-center leading-none">
                    <div className="inline-flex h-4 w-4 items-center justify-center align-middle">
                      <Checkbox
                        id={id}
                        checked={value[permission.object]?.includes(column.action) ?? false}
                        disabled={disabled}
                        onCheckedChange={(checked) =>
                          setChecked(permission.object, column.action, checked === true)
                        }
                      />
                    </div>
                    <Label htmlFor={id} className="sr-only">
                      {permission.label} {column.label}
                    </Label>
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
